import clsx from 'clsx'
import type { ConfigStatus, HealthSummary } from '../model/coverage'

/** Filter selected on the map; `GAPS` shows the gaps block, null = all. */
export type HealthFilter = ConfigStatus | 'GAPS' | null

interface Props {
  health: HealthSummary
  active: HealthFilter
  onSelect: (filter: HealthFilter) => void
}

interface Counter {
  key: Exclude<HealthFilter, null>
  label: string
  value: number
  /** Metronic text/background accent. */
  accent: string
}

/**
 * Health counters as Metronic stat cards. Clicking a counter filters the list;
 * clicking the active counter again clears the filter (handled by the parent).
 */
export const HealthSummaryBar = ({ health, active, onSelect }: Props) => {
  // CHC-874: «Пусто» убран — слит в «Требуют настройки».
  const counters: Counter[] = [
    { key: 'CONFIGURED', label: 'Настроено', value: health.configured, accent: 'success' },
    { key: 'INCOMPLETE', label: 'Неполных', value: health.incomplete, accent: 'warning' },
    { key: 'CONFLICT', label: 'Конфликтов', value: health.conflict, accent: 'danger' },
    { key: 'DISABLED', label: 'Выключена', value: health.disabled, accent: 'dark' },
    { key: 'GAPS', label: 'Требуют настройки', value: health.gaps, accent: 'danger' },
  ]

  return (
    <div className='row g-4 mb-2'>
      {counters.map((c) => {
        const isActive = active === c.key
        return (
          <div className='col-6 col-md-4 col-xl-2' key={c.key}>
            <button
              type='button'
              onClick={() => onSelect(isActive ? null : c.key)}
              className={clsx(
                'card w-100 h-100 border-0 text-start',
                isActive ? `bg-light-${c.accent}` : 'bg-body',
                'shadow-sm'
              )}
              style={{
                cursor: 'pointer',
                outline: isActive ? `2px solid var(--bs-${c.accent})` : 'none',
              }}
              aria-pressed={isActive}
            >
              <div className='card-body p-4'>
                <div className={`fs-2hx fw-bold text-${c.accent}`}>{c.value}</div>
                <div className='fs-7 text-gray-600 fw-semibold'>{c.label}</div>
              </div>
            </button>
          </div>
        )
      })}
    </div>
  )
}
